import { render, staticRenderFns } from "./FollowingStatus.vue?vue&type=template&id=0307644a&scoped=true"
import script from "./FollowingStatus.vue?vue&type=script&lang=js"
export * from "./FollowingStatus.vue?vue&type=script&lang=js"
import style0 from "./FollowingStatus.vue?vue&type=style&index=0&id=0307644a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0307644a",
  null
  
)

export default component.exports